import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';

@Component({
  selector: 'app-email-setup-page',
  standalone: false,
  templateUrl: './email-setup-page.component.html',
  styleUrl: './email-setup-page.component.css'
})
export class EmailSetupPageComponent extends BaseComponent implements OnInit {
  form!: FormGroup;
  userId:string
  loading:boolean=false
  userRole:string
  constructor
    (

      private auth: AuthService,
      private messageService: MessageService,
      private fb: FormBuilder,
      private api: BaseApiService,
    ) {
    super();
    this.userId = this.auth.getUID();
    this.userRole=this.auth.getRoles();
  }


  initilizeForm()
  {
    this.loading=true;
    this.form = this.fb.group({
      uerId: [this.userId],
      delayNotification: [1, [Validators.required, Validators.min(0)]],
      notificationFrequency: ['Daily', [Validators.required]],
      notificationsPerEmail: [0, [Validators.required, Validators.min(0)]],
    });
    this.loading=false;
  }

  ngOnInit(): void {
    this.initilizeForm()
  }

  onSubmit(): void {
    this.loading = true;
    this.api.update("Auth/NotificationDeliverySetup", this.form.value)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        })
      )
    .subscribe
      (

        {
          next:(response) => 
            {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: "Opération réalisée avec succès." });
              this.loading = false;
            },
            error: (
              error
            ) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            }
        }
      )
  }







}
